/**
 * @generated SignedSource<<2b2468a332bed630faf7eead6df562d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeployIntegrity = "DEGRADED" | "HEALTHY" | "SILENT_FALLBACK" | "UNKNOWN" | "%future added value";
export type WebFetchHealthStatus = "ACCESS_IMPAIRED" | "DRIFTING" | "HEALTHY" | "INSUFFICIENT_DATA" | "%future added value";
export type systemStatusQuery$variables = Record<PropertyKey, never>;
export type systemStatusQuery$data = {
  readonly systemStatus: {
    readonly overall: DeployIntegrity;
    readonly services: ReadonlyArray<{
      readonly deploy: DeployIntegrity;
      readonly health: {
        readonly live: boolean;
        readonly ready: boolean;
      };
      readonly name: string;
      readonly runningCommit: string | null | undefined;
      readonly runningVersion: string | null | undefined;
      readonly shippedVersion: string | null | undefined;
    }>;
    readonly webFetchDrift: ReadonlyArray<{
      readonly accessBlocked: number;
      readonly definitionId: any;
      readonly name: string;
      readonly ok: number;
      readonly parseEmpty: number;
      readonly parseFailed: number;
      readonly status: WebFetchHealthStatus;
      readonly total: number;
    }>;
  };
};
export type systemStatusQuery = {
  response: systemStatusQuery$data;
  variables: systemStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SystemStatusView",
    "kind": "LinkedField",
    "name": "systemStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "overall",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ServiceStatus",
        "kind": "LinkedField",
        "name": "services",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deploy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ServiceHealth",
            "kind": "LinkedField",
            "name": "health",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "live",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ready",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "runningVersion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "runningCommit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shippedVersion",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WebFetchDriftState",
        "kind": "LinkedField",
        "name": "webFetchDrift",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "definitionId",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "total",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ok",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parseEmpty",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parseFailed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accessBlocked",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "systemStatusQuery",
    "selections": (v1/*: any*/),
    "type": "AdminQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "systemStatusQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a4cfdc21fd68808a57d26dd24dc6868b",
    "id": null,
    "metadata": {},
    "name": "systemStatusQuery",
    "operationKind": "query",
    "text": "query systemStatusQuery {\n  systemStatus {\n    overall\n    services {\n      name\n      deploy\n      health {\n        live\n        ready\n      }\n      runningVersion\n      runningCommit\n      shippedVersion\n    }\n    webFetchDrift {\n      definitionId\n      name\n      total\n      ok\n      parseEmpty\n      parseFailed\n      accessBlocked\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "aa4b8e8830c2d89e0f7c8ccdab0291d0";

export default node;
